import { useEffect } from "react";
import { applyDesiredParentNavigation } from "../pendingParentNavigation";

export default function useParentRouting() {
  useEffect(() => {
    applyDesiredParentNavigation();
  }, []);
}
